import React, { FunctionComponent } from "react";
import { TagsBlock } from "@/components/responsive/product/tagsBlock/TagsBlock";
import { EnergyClass } from "@/components/responsive/energyClass/EnergyClass";
import { RepairabilityIndex } from "@/components/responsive/product/reparabilityIndex/ReparabilityIndex";
import { CommercialOperations } from "@/models/scope/productSheet/CommercialOperations";
import { ProductFeature } from "@/models/scope/productSheet/ProductFeature";
import Utils from "@/libs/Utils";
import { Offers } from "@/models/scope/productSheet/offer/Offers";
import {ProductDocumentList} from "@/models/scope/productSheet/ProductDocumentList";
interface Props {
    reparabilityIndex: string;
    newEnergyClass: string | null;
    documentId: ProductDocumentList<string> | null,
    commercialOperations: CommercialOperations[];
    soldBy: string,
    elibiblitySoldBy: string[],
    eligibilityToPrivateSale: boolean,
    offersData: Offers | null;
    features: ProductFeature[];
}

export const TagsInsideImage: FunctionComponent<Props> = ({
    reparabilityIndex,
    newEnergyClass,
    commercialOperations,
    elibiblitySoldBy,
    documentId,
    soldBy,
    eligibilityToPrivateSale,
    offersData,
    features,
}) => {
    let maxDisplayedPicto = Utils.getMaxDisplayedCommercialOperationsOfTypeProduct(commercialOperations);
    const oldEnergyClass = features?.find((item: ProductFeature) => item.label == "Classe énergétique");
    const stickersNumbers = commercialOperations?.filter(
        (operation) => operation.type === "Product").length;
    if (newEnergyClass || oldEnergyClass) {
        maxDisplayedPicto -= 1;
    }
    if (reparabilityIndex) {
        maxDisplayedPicto -= 1;
    }
    return (
        <div className="image-tag-container">
            {(!!newEnergyClass || !!oldEnergyClass?.value) &&
                <EnergyClass documentId={documentId} isNewEnergyClass={!!newEnergyClass}
                             energyClass={newEnergyClass || oldEnergyClass?.value || ''}/>}
            {!!reparabilityIndex && <RepairabilityIndex documentId={documentId} score={reparabilityIndex}/>}
            {(commercialOperations?.length || 0) > 0 && (
                <TagsBlock
                    commercialOperations={commercialOperations.filter(
                        (operation) => operation.type === "Product"
                    ).filter((item, index) => ((maxDisplayedPicto > index) && (index < stickersNumbers)))}
                    isColumnDirection={true}
                    eligibilityToPrivateSale={eligibilityToPrivateSale} eligibleSoldBy={elibiblitySoldBy}
                    soldBy={soldBy} maxDisplayedPicto={maxDisplayedPicto} stickersNumbers={stickersNumbers} offersData={offersData} />
            )}
        </div>
    );
};